import { useTranslation } from "react-i18next";
import { RadioButton } from "../RadioButton/RadioButton";
import { RadioButtonContainer } from "../../layout/FormLayout";
import type { GroupAttributeListGridViewModeRadiosProps } from "./objectReference.types";
import { spacingTokens } from "../../designTokens";

const listGridViewModeContainerStyle = {
  margin: `${spacingTokens.spacing_md} 0`,
} as const;

export function GroupAttributeListGridViewModeRadios({
  namePrefix,
  currentViewMode,
  onViewModeChange,
}: GroupAttributeListGridViewModeRadiosProps) {
  const { t } = useTranslation();
  return (
    <RadioButtonContainer style={listGridViewModeContainerStyle}>
      <RadioButton
        name={namePrefix}
        value="link"
        checked={currentViewMode === "link"}
        optionTitle={t("List View")}
        handleChange={onViewModeChange}
      />
      <RadioButton
        name={namePrefix}
        value="product_card"
        checked={currentViewMode === "product_card"}
        optionTitle={t("Grid View")}
        handleChange={onViewModeChange}
      />
    </RadioButtonContainer>
  );
}
